export default __webpack_public_path__ + "static/media/drumpad.293a4b01.jpg";